export default "__VITE_ASSET__DSfR6l3n__"